import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { AccessGateContext } from "../context/accessGateContext";

export default function useVendorAccessGate() {
  const { canAccessVendorArea } = useContext(AccessGateContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!canAccessVendorArea) {
      navigate("/");
    }
  }, [canAccessVendorArea, navigate]);
}

